import React from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';

interface Props {
  memberTickets: number;
  publicTickets: number;
}
const Status: React.FC<Props> = (props) => {
  const { publicTickets = 0, memberTickets = 0 } = props;
  return (
    <div style={{ marginTop: 20 }}>
      <Paper style={{ padding: 20 }}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant='h4'>Public Raffle</Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container direction='row'>
              <Typography variant='body1'>Tickets Sold: </Typography>
              <Typography style={{ paddingLeft: 10 }}>
                {publicTickets} (${publicTickets * 6})
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='h4'>Member Raffle</Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container direction='row'>
              <Typography variant='body1'>Tickets Sold: </Typography>
              <Typography style={{ paddingLeft: 10 }}>
                {memberTickets} (${memberTickets * 6})
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default Status;
